import IconButton from '@/features/ui/buttons/components/IconButton'
import MinusIcon from '@/features/ui/icons/components/MinusIcon'
import { FC } from 'react'

interface DecreaseQuantityButtonProps {
    disabled?: boolean
    onPress: () => void
}

const DecreaseQuantityButton: FC<DecreaseQuantityButtonProps> = ({ disabled, onPress }) => {
    return (
        <IconButton
            disabled={disabled}
            type="outline"
            color="secondary"
            size={44}
            onPress={onPress}
            Icon={MinusIcon}
            testID="decrease-quantity-button"
        />
    )
}

export default DecreaseQuantityButton
